import { auditDate, sources } from './source'

export type SourcedValue<T> = {
  value: T
  source: keyof typeof sources
  auditedAt: typeof auditDate
}

/** Facts that may be presented only with the stated evidence and date. */
export const companyManifest = {
  legalName: { value: 'TS Auto', source: 'companySummary', auditedAt: auditDate },
  location: {
    value: 'San Giorgio delle Pertiche, provincia di Padova',
    source: 'companySummary',
    auditedAt: auditDate,
  },
  founders: { value: ['Pietro Tusa', 'Vasile Tusa'], source: 'companySummary', auditedAt: auditDate },
  business: {
    value: 'Vendita di auto nuove, usate e veicoli commerciali selezionati.',
    source: 'companySummary',
    auditedAt: auditDate,
  },
  claims: [
    { value: 'Chilometraggio verificato.', source: 'companySummary', auditedAt: auditDate },
    { value: 'Veicoli usati con garanzia fino a 24 mesi e tagliando alla consegna.', source: 'companySummary', auditedAt: auditDate },
    { value: '4,9/5 su 221 recensioni Google.', source: 'companySummary', auditedAt: auditDate, staleAfter: auditDate },
  ],
  partners: [
    'ConformGest',
    'Adiconsum',
    'Non Prendermi per il Km',
    'Compass',
    'Fiditalia',
    'Bosch Car Service',
  ].map((value) => ({ value, source: 'companySummary' as const, auditedAt: auditDate })),
} as const

/** The audit did not capture these values. They must not be invented in UI or metadata. */
export const companyGaps = [
  'Ragione sociale completa e partita IVA.',
  'Indirizzo stradale, numeri telefonici, email e orari verificati.',
  'URL e natura contrattuale dei partner.',
  'Testo e destinazione verificata di TS Garage e Rivenditore Certificato.',
] as const
